import React from 'react';
import styles from './style.module.css';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';
import { useTranslation } from 'react-i18next';
import { TransportRegisterByCategoryResponse } from '../api/types';

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

interface Props {
  data?: TransportRegisterByCategoryResponse;
}

export const DynamicsByYears: React.FC<Props> = ({ data }) => {
  const { t, i18n } = useTranslation();

  if (!data?.res || data.res.length === 0) {
    return null;
  }

  const categories = data.res[0]?.categories || [];
  const years = data.res.map(item => item.year);

  const chartData = {
    labels: categories.map(cat => 
      i18n.language === 'ky' ? cat.category.nameKy : cat.category.nameRu
    ),
    datasets: years.map((year, index) => ({
      label: year.toString(),
      data: categories.map(category => {
        const yearData = data.res.find(d => d.year === year);
        const categoryData = yearData?.categories.find(
          c => c.category.id === category.category.id
        );
        return categoryData?.totalQuantity || 0;
      }),
      backgroundColor: getColor(index),
      borderRadius: 6,
      barThickness: 30,
    })),
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'bottom' as const,
        labels: {
          padding: 20,
          usePointStyle: true,
          pointStyle: 'circle' as const,
        },
      },
      title: {
        display: true,
        text: t('Yearly dynamics'),
        font: {
          size: 16,
          weight: 'bold' as const,
        },
        padding: {
          bottom: 30
        }
      }
    },
    scales: {
      x: {
        grid: {
          display: false
        }
      },
      y: {
        grid: {
          color: '#E5E7EB',
          drawBorder: false
        },
        ticks: {
          padding: 10
        }
      },
    },
  };

  return (
    <div className={styles.container}>
      <div className={styles.chartContainer}>
        <Bar options={options} data={chartData} />
      </div>
    </div>
  );
};

function getColor(index: number): string {
  const colors = [
    'rgba(38, 144, 0, 1)',   // Яркий зеленый
    'rgba(255, 154, 2, 1)',  // Светло-желтый
    'rgba(180, 211, 31, 1)',  // Оранжевый
  ];
  return colors[index % colors.length];
}